import * as React from 'react'

const Clock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    aria-label='Clock logo'
    fill='none'
    height='18'
    role='img'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width='18'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Clock logo</title>
    <circle cx='12' cy='12' r='10' />
    <polyline points='12 6 12 12 16 14' />
  </svg>
)

export default Clock



// WEBPACK FOOTER //
// ./src/components/icons/ui/Clock.tsx